import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './style1.css';

interface AddImageProps {
    username: string | null;
    onLogout?: () => void;
}

const navLinks = [
    { name: 'HOME', href: '/' },
    { name: 'PROGRAMS', href: '/programs' },
    { name: 'VIDEOS', href: '/videos' },
    { name: 'IMAGES', href: '/images' },
    { name: 'DEMOS', href: '/demos' },
    { name: 'CERTIFICATES', href: '/certificates' },
    { name: 'ABOUT', href: '/about' },
];

const AddImage: React.FC<AddImageProps> = ({ username, onLogout }) => {
    const [name, setName] = useState('');
    const [program, setProgram] = useState('');
    const [url, setUrl] = useState('/images/');
    const [directory, setDirectory] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    if (username !== 'admin') {
        return <div style={{ textAlign: 'center', marginTop: '2rem' }}>Access denied.</div>;
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!name.trim() || !program.trim() || !url.trim() || !directory.trim()) {
            setError('All fields are required.');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/addimage', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                },
                body: JSON.stringify({ name, program, url, directory })
            });
            if (response.ok) {
                setSuccess('Image added!');
                setName('');
                setProgram('');
                setUrl('/images/');
                setDirectory('');
            } else {
                let data;
                try {
                    data = await response.json();
                } catch {
                    data = {};
                }
                setError((data && data.message) || 'Failed to add image.');
            }
        } catch {
            setError('Network error.');
        }
    };

    return (
        <div className="modern-layout">
            <header className="modern-header">
                <div className="header-container">
                    <nav className="modern-nav">
                        {navLinks.map(link =>
                            link.href.startsWith('/')
                                ? <Link
                                    key={link.name}
                                    to={link.href}
                                    className="modern-nav-link"
                                    style={{ textDecoration: 'none' }}
                                  >
                                    {link.name}
                                  </Link>
                                : <a
                                    key={link.name}
                                    href={link.href}
                                    className="modern-nav-link"
                                  >
                                    {link.name}
                                  </a>
                        )}
                        {onLogout && (
                            <button className="logout-btn" onClick={onLogout}>LOG OUT</button>
                        )}
                    </nav>
                </div>
            </header>
            <main className="modern-content">
                <div
                    style={{
                        maxWidth: 500,
                        margin: '2rem auto',
                        background: '#fff',
                        borderRadius: 12,
                        boxShadow: '0 2px 16px #6a11cb22',
                        padding: '2rem'
                    }}
                >
                    <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>Add Image</h2>
                    <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: '1rem' }}>
                            <label>Name<span style={{ color: 'red' }}>*</span>:</label>
                            <input
                                type="text"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                style={{ width: '100%', padding: '0.5rem', marginTop: 4 }}
                                required
                            />
                        </div>
                        <div style={{ marginBottom: '1rem' }}>
                            <label>Program<span style={{ color: 'red' }}>*</span>:</label>
                            <input
                                type="text"
                                value={program}
                                onChange={e => setProgram(e.target.value)}
                                style={{ width: '100%', padding: '0.5rem', marginTop: 4 }}
                                required
                            />
                        </div>
                        <div style={{ marginBottom: '1rem' }}>
                            <label>URL<span style={{ color: 'red' }}>*</span>:</label>
                            <input
                                type="text"
                                value={url}
                                onChange={e => setUrl(e.target.value)}
                                style={{ width: '100%', padding: '0.5rem', marginTop: 4 }}
                                required
                            />
                        </div>
                        <div style={{ marginBottom: '1rem' }}>
                            <label>Directory<span style={{ color: 'red' }}>*</span>:</label>
                            <input
                                type="text"
                                value={directory}
                                onChange={e => setDirectory(e.target.value)}
                                style={{ width: '100%', padding: '0.5rem', marginTop: 4 }}
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 6,
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            Add
                        </button>
                    </form>
                    {error && <div style={{ color: 'red', marginTop: '1rem' }}>{error}</div>}
                    {success && <div style={{ color: 'green', marginTop: '1rem' }}>{success}</div>}
                </div>
            </main>
            <footer className="modern-footer">
                &copy; {new Date().getFullYear()} Timo
            </footer>
        </div>
    );
};

export default AddImage;